import draw from './draw';

export default (
  mouseEvents,
  wgDimension,
  lastShipment,
  isSingleColumn,
  isPrambananConfig,
) => (selection) => {
  selection.selectAll('svg').remove();

  const root = selection.selectAll('svg').data(selection.data());
  root.exit().remove();

  const spaceScrollY = 8;
  const containerPadding = isSingleColumn ? 80 : 30;
  const containerWidth = wgDimension.width - containerPadding - spaceScrollY;

  const svg = root
    .enter()
    .append('svg')
    .attr('width', containerWidth)
    .attr('height', 75);

  svg
    .append('g')
    .classed('viewport', true)
    .style('transform', 'translate(0, 0)')
    .call(draw(mouseEvents, containerWidth, lastShipment, isPrambananConfig));
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/index.js